import router from '@/scripts/router';
import eventProxy from '@/scripts/tools/eventProxy';
import storage from '@/scripts/tools/storage';
import { mutations } from '@/scripts/store';
import oauth from './oauth';

// 路由跳转
function RouteJump(currentRoute) {
  mutations.changeLocaleLanguage(currentRoute.query.lang);
  setTimeout(() => {
    router.replace({
      name: currentRoute.name,
      query: { bucket: currentRoute.query.bucket, region: currentRoute.query.region, path: currentRoute.query.path },
    });
  }, 3000);
}

// 未登录时跳转到登录页面
function RouteJumpLogin(currentRoute) {
  if (currentRoute.name === 'web') {
    router.replace({ name: 'login' }).catch(() => {});
  } else {
    const setPath = encodeURIComponent(currentRoute.fullPath);
    router.replace(`/login/?r_path=${setPath}`).catch(() => {});
  }
}

// 来自console跳转到oauth页面登录
function RouteJumpOauth(currentRoute) {
  const pathObject = {
    name: currentRoute.name,
    query: currentRoute.query,
  };
  oauth.getCloudLoginUrl().then(url => {
    if (!url) return;
    const { clientId, clientCode } = oauth;
    storage.add('oauth_cache', { clientId, clientCode });
    storage.add('set_path', pathObject, 'session');
    window.location.href = url;
  });
}

// 跳转到编辑器模式or文件编辑
function RouteJumpEdit(currentRoute) {
  if (currentRoute.name === 'file') {
    if (currentRoute.query.key) {
      const editKey = currentRoute.query.key;
      const editPath = decodeURIComponent(editKey);
      currentRoute.query.path = editPath;
    }
    RouteJump(currentRoute);
    setTimeout(() => {
      eventProxy.emit('command.edit', currentRoute.query);
    }, 1000);
  } else if (currentRoute.name === 'editor') {
    RouteJump(currentRoute);
  }
}

const Route = {
  RouteJump,
  RouteJumpLogin,
  RouteJumpOauth,
  RouteJumpEdit,
};

export default Route;
